import TYPES from '@/modules/shared/types';

// Domain
import {
  LevelOfEducationRepository,
} from '@/modules/flagship/catalogs/level-of-education/domain/repositories/level-of-education-repository';
import {
  LevelOfEducationEntity,
} from '@/modules/flagship/catalogs/level-of-education/domain/entities/level-of-education-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class LevelOfEducationHttpRepository
implements LevelOfEducationRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/catalogs/level-of-education/`;

  execute(): Promise<Array<LevelOfEducationEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
